<template>
    <v-flex xl12>
        <h2>Usuários <span class="text-title-header"> | Cadastro de usuários</span></h2>
        <v-divider></v-divider>
        <br/>
        <router-view></router-view>
    </v-flex>
</template>
<script>
export default {
  name: 'users',
  mounted: function () {
    this.$nextTick(function () {

    })
  }
}
</script>
